import { jsx as e } from "react/jsx-runtime";
import { useChatbotContext as m } from "../../hooks/useChatbotContext.js";
function s(o) {
  const { formRef: r, handleSubmit: t } = m();
  return /* @__PURE__ */ e("form", { ...o, ref: r, onSubmit: t });
}
export {
  s as UserMessageForm
};
